import Vue from 'vue';

import {
  isValidChassie,
} from '@/utils';

import {
  CustomInput,
  InputChassie,
} from '@/components';

import {
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  required,
  regex,
} from 'vee-validate/dist/rules';

export default {
  name: 'VehicleDataForm',
  components: {
    ValidationObserver,
    ValidationProvider,
    [CustomInput.name]: CustomInput,
    [InputChassie.name]: InputChassie,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    gearboxTypes: [
      {
        text: Vue.prototype.$gettext('Component - Vehicle data form - GearboxType - Automatic'),
        value: 1,
      },
      {
        text: Vue.prototype.$gettext('Component - Vehicle data form - GearboxType - Manual'),
        value: 2,
      },
    ],
    fuelTypes: [
      {
        text: Vue.prototype.$gettext('Component - Vehicle data form - FuelType - Benzine'),
        value: 1,
      },
      {
        text: Vue.prototype.$gettext('Component - Vehicle data form - FuelType - Hybride'),
        value: 2,
      },
      {
        text: Vue.prototype.$gettext('Component - Vehicle data form - FuelType - Diesel'),
        value: 3,
      },
      {
        text: Vue.prototype.$gettext('Component - Vehicle data form - FuelType - Elektrisch'),
        value: 4,
      },
    ],
  }),
  computed: {
    ...mapGetters('appointment', {
      language: 'getLanguage',
      vehicleDataState: 'getVehicleData',
      getChassie: 'getChassie',
    }),
    chassie: {
      get() {
        return this.getChassie;
      },
      set(newChassie) {
        this.setChassie = newChassie;

        return newChassie;
      },
    },
    selectedGearboxType: {
      get() {
        return this.vehicleDataState.gearbox;
      },
      set(newModel) {
        if (newModel != null) {
          const changeVehicleDataStateObject = {
            state: newModel,
            property: 'gearbox',
          };
          this.setVehicleDataMutation(changeVehicleDataStateObject);
        }

        return newModel;
      },
    },
    selectedFuelType: {
      get() {
        return this.vehicleDataState.fuel;
      },
      set(newModel) {
        if (newModel != null) {
          const changeVehicleDataStateObject = {
            state: newModel,
            property: 'fuel',
          };

          this.setVehicleDataMutation(changeVehicleDataStateObject);
        }

        return newModel;
      },
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setChassie: 'SET_CHASSIE',
      setVehicleDataMutation: 'SET_VEHICLEDATA',
    }),
    save() { },
    setValidationMessages() {
      // Vee-validate
      extend('required', {
        ...required,
        message: Vue.prototype.$gettext('Validation - Required error'),
      });

      extend('regex', {
        ...regex,
        message: Vue.prototype.$gettext('Validation - Regex error'),
      });

      extend('validChassie', {
        validate: value => isValidChassie(value),
        message: Vue.prototype.$gettext('Chassie - Error'),
      });
    },
  },
  watch: {
    language() {
      this.setValidationMessages();
    },
  },
  created() {
    this.setValidationMessages();
  },
};
